/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGeoforceExit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c3.875 0 6.991 3.315 6.991 7.375l.01.2c.015.917-.193 2.2-.782 3.79-.956 2.582-2.725 5.378-5.49 8.32L12 22.46l-.729-.775c-2.764-2.942-4.533-5.738-5.49-8.32-.63-1.703-.825-3.055-.775-3.982l.003-.045.004-.21c.121-3.865 3.064-6.995 6.75-7.124zm0 2C9.258 4 7.01 6.393 7.01 9.375l-.006.105-.005.148c-.009.667.16 1.696.658 3.042.744 2.008 2.057 4.198 4.067 6.53l.276.315.276-.315c1.905-2.21 3.184-4.291 3.945-6.211l.122-.319c.534-1.442.69-2.52.654-3.18l-.01-.343C16.876 6.272 14.672 4 12 4zm1.293 2.293 1.414 1.414L13.415 9l1.292 1.293-1.414 1.414L12 10.414l-1.293 1.293-1.414-1.414L10.586 9 9.293 7.707l1.414-1.414L12 7.585z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGeoforceExit as GeoforceExit };
